import { Typography, Divider } from 'antd';
import React from "react";
import NoSidebarLayout from "../../components/Layout/NoSidebarLayout";
import "./styles.scss";
const { Title, Paragraph, Text } = Typography;


const TermsAndConditionsPage: React.FC = () => {
  return (
    <NoSidebarLayout classOverrides="w-full sm:w-2/3 flex justify-center m-auto p-2 min-h-screen">
        <Typography>
            <Title>
                iLivestock TERMS OF USE
            </Title>
            <Title level={3}>
                V1.0 May 2018
            </Title>
            <Title level={4}>
                PLEASE READ CAREFULLY BEFORE USING THE APP
            </Title>
            <Paragraph>
                These terms (Terms) govern your use of the iLivestock mobile application software, the data supplied with the software, and any associated media (collectively the App) and constitute a legal agreement between you (user or you) and Duradiamond Software Limited, with company number SC414828, whose registered office is The Steadings, Laigh of Rossie, Whitemoss Road, Dunning, Perthshire, United Kingdom PH2 0QY (us or we).
            </Paragraph>
            <Title level={4}>
                IMPORTANT NOTICE:
            </Title>
            <Paragraph>
                By downloading the App or clicking on the 'Accept Terms and Conditions' button or simply by continuing to use this App you agree to these Terms. These Terms include and incorporate the Privacy Policy.
                If you do not agree to these Terms in their entirety and on an unqualified basis, you must stop the downloading process now and not access or use the App.
                We license you to use the App on the basis of these Terms and in addition to any rules or policies (Appstore Rules) applied by any operator from whose site you downloaded the App whether located at www.store.apple.com or otherwise (Appstore). IN THE EVENT THERE IS A CONFLICT BETWEEN THESE TERMS, THE PRIVACY POLICY AND THE APPSTORE RULES, THEN THE APPSTORE RULES SHALL PREVAIL.
            </Paragraph> 

            <Paragraph>
                <ol>
                    <li>
                        <Text strong>ACKNOWLEDGEMENTS</Text>
                    </li>
                    <ol>
                        <li>
                            These Terms apply to the App or any of the services accessible through the App (Services), including any updates or supplements to the App or any Service, unless they come with specific separate terms, in which case those terms may apply in addition to these Terms. If any open-source software is included in the App or any Service, the terms of an open-source licence may apply alongside and/or override some of these Terms.
                        </li>
                        <li>
                        We may change these Terms at any time. The new terms may be displayed on-screen and you may be required to read and accept them to continue your use of the App.
                        </li>
                        <li>
                        From time to time updates to the App may be issued through any Appstore. Depending on the update, you may not be able to use the App or Services until you have downloaded the latest version of the App and accepted any new terms which may apply.
                        </li>
                        <li>
                        All devices used to download and use the App shall be referred to as 'Devices' in these Terms. To the extent that you are not the owner of such Device you are responsible for and will be assumed to have obtained permission from the owners of the Device that is or are controlled, but not owned, by you to download a copy of the App onto the Device. You and/or any applicable owner of such Device may be charged by your and/or their service provider(s) for internet access on the Device. Such internet access charges are not included in any charges otherwise associated with the App. You accept responsibility in accordance with these Terms for the use of the App or any Service on or in relation to any Device, whether or not it is owned by you.
                        </li>
                        <li>
                        By using the App or any Service, you acknowledge and agree that internet transmissions are never completely private or secure. You understand that any message or information you send using the App or any Service may be read or intercepted by others, even if there is a special notice that a particular transmission is encrypted.
                        </li>
                        <li>
                        By using the App or any of the Services, you consent to us collecting and using technical information about the Devices and related software, hardware and peripherals for Services that are internet-based or wireless to improve our products and to provide Services to you.
                        </li>
                        <li>
                        Certain Services will make use of location data sent from the Device. If enabled by the particular Device you are using you can turn off this functionality at any time by turning off the location services settings for the App on the Device. If you use these Services, you consent to us and our affiliates' and licensees' transmission, collection, maintenance, processing and use of your location data and queries to provide and improve location-based products and services. You may withdraw this consent at any time by turning off the location services settings on the applicable Device.
                        </li>
                        <li>
                        The App or any Service may contain links to other independent third-party websites (Third-party Sites). Third-party Sites are not under our control, and we are not responsible for and do not endorse their content or their privacy policies (if any). You will need to make your own independent judgement regarding your interaction with any Third-party Sites, including the purchase and use of any products or services accessible through them. We will not be liable for any loss or damage that may arise from your use of such Third-Party Sites.
                        </li>
                        <li>
                        Any words following the terms including, include, in particular or for example or any similar phrase shall be construed as illustrative and shall not limit the generality of the related general words.
                        </li>
                    </ol>
                    <li>
                        <Text strong>GRANT AND SCOPE OF LICENCE</Text>
                    </li>
                    <ol>
                        <li>
                            In consideration of you agreeing to comply with these Terms, we grant you a non-transferable, non-exclusive licence to use the App for the purpose for which it was intended on the Device, subject to these Terms, the Privacy Policy and the Appstore Rules, incorporated into these Terms by reference. We reserve all other rights.
                        </li>
                        <li>
                            You may download a copy of the App, view, use and display the App on the Devices for your personal use only AND you are NOT permitted to download, operate or use the App on behalf of any third party and/or for commercial gain.
                        </li>
                    </ol>
                    <li>
                        <Text strong>LICENCE RESTRICTIONS</Text>
                    </li>
                    <ol>
                        <li>
                            Except as expressly set out in these Terms or as permitted by any local law, you agree to comply with the following "Licence Restrictions", in each case whether the restricted activity is carried out directly by you or indirectly for you or on your behalf:
                        </li>
                        <li>
                            not to copy the App except where such copying is incidental to normal use of the App, or where it is necessary for the purpose of back-up or operational security;
                        </li>
                        <li>
                            not to rent, lease, sub-license, loan, translate, merge, adapt, vary or modify the App;
                        </li>
                        <li>
                            not to make alterations to, or modifications of, the whole or any part of the App, or permit the App or any part of it to be combined with, or become incorporated in, any other programs;
                        </li>
                        <li>
                            not to disassemble, decompile, reverse-engineer or create derivative works based on the whole or any part of the App or attempt to do any such thing;
                        </li>
                        <li>
                            to keep all copies of the App secure and to maintain accurate and up-to-date records of the number and locations of all copies of the App;
                        </li>
                        <li>
                            not to use on behalf of any third party and not to provide or otherwise make available the App in whole or in part in any form to any person without prior written consent from us;
                        </li>
                        <li>
                            to comply with all technology control or export laws and regulations that apply to the technology used or supported by the App or any Service; and
                        </li>
                        <li>
                            not to use the App with any unauthorised and or modified ("jailbroken" or equivalent) operating system on your Device.
                        </li>
                    </ol>
                    <li>
                        <Text strong>ACCEPTABLE USE RESTRICTIONS</Text>
                        <div>You must not:</div>
                        
                    </li>
                    <ol>
                        <li>
                            use the App or any Service in any unlawful manner, for any unlawful purpose, or in any manner inconsistent with these Terms, or act fraudulently or maliciously, for example, by hacking into or inserting malicious code, including viruses, or harmful data, into the App, any Service or any operating system;
                        </li>
                        <li>
                            infringe our intellectual property rights or those of any third party in relation to your use of the App or any Service, including the submission of any material (to the extent that such use is not licensed by these Terms);
                        </li>
                        <li>
                            transmit any material that is defamatory, offensive or otherwise objectionable in relation to your use of the App or any Service;
                        </li>
                        <li>
                            use the App or any Service in a way that could damage, disable, overburden, impair or compromise our systems or security or interfere with other users;
                        </li>
                        <li>
                            collect or harvest any information or data from the App or any Service or our systems or attempt to decipher any transmissions to or from the servers running the App or any Service;
                        </li>
                        <li>
                            attempt to resell and/or sub-licence the App to any third party without our specific written consent; and/or
                        </li>
                        <li>
                            use the App or any Service in any way (whether negative or derogatory or otherwise) that could result in damage to our reputation and/or goodwill.
                        </li>
                        <Paragraph>
                            You must comply with these Acceptable Use Restrictions at all times.
                        </Paragraph>
                    </ol>
                    <li>
                        <Text strong>YOUR ACCOUNT</Text>
                    </li>
                    <ol>
                        <li>
                            The use of the App by a minor is subject to the consent of their parent or guardian. We encourage parents who permit their children to use the App to communicate with their children about the importance of their safety online. Minors who are using the App should be made aware of the potential risks to them.
                        </li>
                        <li>
                            On creating your iLivestock account you agree to provide complete and accurate information as may be requested. You must treat all account information and access information such as passwords and usernames as confidential and must not disclose any such information to any third party. We accept no responsibility for unauthorised use of the App or any Service through your account.
                        </li>
                        <li>
                            If you know of or suspect that anyone other than you knows your user identification name or password or who has used your account without your consent, you must promptly notify us and/or change all such password information as required.
                        </li>
                        <li>
                            We have the right to disable any user identification code or password, whether chosen by you or allocated by us, at any time, if in our reasonable opinion you have failed to comply with any of the provisions of these Terms.
                        </li>
                    </ol>
                    <li>
                        <Text strong>CONTENT</Text>
                    </li>
                    <ol>
                        <li>
                            Whenever you upload content to the App, you must comply with the content standards set out below.
                        </li>
                        <li>
                            Contributions must not:
                            <div>
                                contain any material which is defamatory of any person;
                            </div>
                            <div>
                                contain any material which is obscene, offensive, hateful or inflammatory;
                            </div>
                            <div>
                                promote sexually explicit material;
                            </div>
                            <div>
                                promote violence;
                            </div>
                            <div>
                                promote discrimination based on race, sex, religion, nationality, disability, sexual orientation or age;
                            </div>
                            <div>
                                infringe any intellectual property rights, including but not limited to copyright, database right or trade mark, of any other person;
                            </div>
                            <div>
                                be likely to deceive any person;
                            </div>
                            <div>
                                be made in breach of any legal duty owed to a third party, such as a contractual duty or a duty of confidence;
                            </div>
                            <div>
                                promote any illegal activity;
                            </div>
                            <div>
                                be threatening, abusive or invade another's privacy, or cause annoyance, inconvenience or needless anxiety;
                            </div>
                            <div>
                                be likely to harass, upset, embarrass, alarm or annoy any other person;
                            </div>
                            <div>
                                be used to impersonate any person, or to misrepresent your identity or affiliation with any person;
                            </div>
                            <div>
                                give the impression that they emanate from us, if this is not the case; or
                            </div>
                            <div>
                                advocate, promote or assist any unlawful act such as (by way of example only) copyright infringement or computer misuse.
                            </div>
                        </li>
                        <li>
                            Any content you upload to the App will be considered non-confidential and non-proprietary, and we have the right to (and you grant us a perpetual, irrevocable and royalty-free licence to) use, copy, distribute and disclose to third parties any such content for any purpose whatsoever.
                        </li>
                        <li>
                            We also have the right to disclose your identity to any third party who is claiming that any content posted or uploaded by you to the App constitutes a violation of their intellectual property rights, their right to privacy or any other rights.
                        </li>
                        <li>
                            You warrant that any such contribution complies with this clause , and you will be liable to us and indemnify us for any breach of that warranty.
                        </li>
                    </ol>
                    <li>
                        <Text strong>PURCHASING CREDITS</Text>
                    </li>
                    <ol>
                        <li>
                            You should note that the functionality of the App upon download is limited. To unlock and increase the functionality of the App it is necessary to purchase additional credits to carry out various different operations using the App.
                        </li>
                        <li>
                            You can purchase "bundles" of credits in varying denominations from the Appstore ("Credits"), which can be redeemed on the App in exchange for creating additional records in databases of certain information relating to animals, such information shall be managed by the App and stored on the Device ("Records").
                        </li>
                        <li>
                            Your purchase of such Credits is strictly subject to the online purchasing and payment terms of each Appstore. We are in no way responsible for such purchases.
                        </li>
                        <li>
                            The cost of Credits will be set out on our website at www.ilivestock.co.uk and is available on the App within the "Credit Store", and we can, at our sole discretion, change the price of such Credits from time to time.
                        </li>
                    </ol>
                    <li>
                        <Text strong>REDEEMING CREDITS</Text>
                    </li>
                    <ol>
                        <li>
                            The Credit value of each Record will be set out on our website at www.ilivestock.co.uk and is available on the App within the "Credit Store", and we can, at our sole discretion, change the listed values from time to time.
                        </li>
                        <li>
                            Credits are valid for a single-use only on the App and are non-refundable.
                        </li>
                        <li>
                            When redeeming your Credits you are solely responsible for ensuring all information you submit via the App is accurate.
                        </li>
                        <li>
                            On submitting the requisite information or scanning a tag, the Record will be available immediately via the App. On creating such Record the number of applicable Credits will automatically be debited from your account.
                        </li>
                        <li>
                            If you insert incorrect information on your request, or select the wrong category or criteria on your submission, the applicable Credit will still be debited from your App Account. You must archive the incorrect record and submit a request for a new, correct, record at the applicable Credit value.
                        </li>
                        <li>
                            Where you have an insufficient number of Credits for a Record you will only be permitted to download and view a non-editable, non-actionable Record. In order for you to edit and/or action the Record you will need to purchase the required amount of Credits via the Appstore, following which, the Record will become editable and/or actionable.
                        </li>
                        <li>
                            Where you have purchased Credits from the Appstore and these do not appear in your App Account, please notify the Appstore directly.
                        </li>
                    </ol>
                    <li>
                        <Text strong>COMPLIANCE</Text>
                    </li>
                    <ol>
                        <li>
                            Whilst the App is designed to help users satisfy compliance obligations, we make no guarantee, warranty or representation that such compliance will be achieved through using the App. You are responsible for ensuring your own compliance with any and all relevant legislation and regulations.
                        </li>
                    </ol>
                    <li>
                        <Text strong>DATA</Text>
                    </li>
                    <ol>
                        <li>
                            You are responsible for backing up all Records and associated data supplied to you via the App. Such back up can be performed through connecting with iTunes.
                        </li>
                        <li>
                            We are facilitating the distribution of data through the App only. We are not responsible for the accuracy or completeness of any Records downloaded via the App, nor are we responsible for any loss of data you may suffer whilst using the App.
                        </li>
                    </ol>
                    <li>
                        <Text strong>INTELLECTUAL PROPERTY RIGHTS</Text>
                    </li>
                    <ol>
                        <li>
                            You acknowledge that all intellectual property rights in the App (including but not limited to rights in the images, text, code, graphical designs, and logos) and the Services anywhere in the world belong to us or our licensors, that rights in the App are licensed (not sold) to you, and that you have no rights in, or to, the App or the Services other than the right to use each of them in accordance with these Terms.
                        </li>
                        <li>
                            You acknowledge that you have no right to have access to the App in source-code form.
                        </li>
                    </ol>
                    <li>
                        <Text strong>NO WARRANTY</Text>
                    </li>
                    <ol>
                        <li>
                            We make no warranty or representation about the accuracy or completeness of the App's content, or the content of any sites linked to on the App. Nor do we warrant that the use of the App will be uninterrupted or error-free.
                        </li>
                    </ol>
                    <li>
                        <Text strong>LIMITATION OF LIABILITY</Text>
                    </li>
                    <ol>
                        <li>
                            Other than as stated in these Terms all warranties expressed or implied whether by statute common law or otherwise are excluded to the fullest extent permitted by law.
                        </li>
                        <li>
                            Subject to clause  we shall not be liable for any direct, indirect, incidental, special, punitive or consequential damages whatsoever resulting from any:
                        </li>
                        <ol>
                            <li>
                                errors, mistakes or inaccuracies of content on the App;
                            </li>
                            <li>
                                unauthorised access to or use of servers and to all information stored on such servers;
                            </li>
                            <li>
                                interruption or cessation of transmission to or from our App;
                            </li>
                            <li>
                                bugs, viruses that may be transmitted to or through our App by a third party;
                            </li>
                            <li>
                                loss or damage of any kind incurred as a result of the use of, or reliance on, any content posted, emailed, transmitted, or otherwise made available via the App;
                            </li>
                            <li>
                                other losses relating to your use of the App.
                            </li>
                        </ol>
                        <li>
                            We shall not be liable for any user submissions or any defamatory, offensive or illegal conduct of any third party, nor are we responsible for any direct, indirect, incidental, special, punitive or consequential damages whatsoever resulting from any third party event hosted, advertised, or linked to on the App.
                        </li>
                        <li>
                            We only supply the App for private use. You agree not to use the App for any commercial or business or purposes other than for your own specific use.
                        </li>
                        <li>
                            We shall have no liability to you for any loss of profit, loss of business, business interruption, loss of business opportunity, loss of reputation or loss of goodwill and such losses are excluded whether they are direct, indirect, consequential or otherwise.
                        </li>
                        <li>
                            We assume no responsibility for the content of websites linked on the App. Such links should not be interpreted as endorsement by us of those linked websites. We will not be liable for any loss or damage that may arise from your use of them.
                        </li>
                        <li>
                            You shall indemnify us for any loss which we suffer due to your breach of these Terms or due to the breach of any third parties' rights.
                        </li>
                        <li>
                            Nothing in these Terms shall limit or exclude our liability for:
                        </li>
                        <ol>
                            <li>
                                death or personal injury resulting from our negligence;
                            </li>
                            <li>
                                fraud or fraudulent misrepresentation; and
                            </li>
                            <li>
                                any other liability that cannot be excluded or limited by English law.
                            </li>
                        </ol>
                    </ol>
                    <li>
                        <Text strong>TERMINATION</Text>
                    </li>
                    <ol>
                        <li>
                            We may terminate these Terms and any agreements formed by them immediately by written notice to you:
                        </li>
                        <ol>
                            <li>
                                if you commit a material or persistent breach of these Terms which you fail to remedy (if remediable) within 14 days after the service of written notice requiring you to do so;
                            </li>
                            <li>
                                if you breach any of the Licence Restrictions or the Acceptable Use Policy; and
                            </li>
                            <li>
                                for any other reason at our sole discretion.
                            </li>
                        </ol>
                        <li>
                            On termination for any reason:
                        </li>
                        <ol>
                            <li>
                                all rights granted to you under these Terms shall cease;
                            </li>
                            <li>
                                we may prevent your access to, or use of, the App or the Services by disabling your account;
                            </li>
                            <li>
                                you must immediately cease all activities authorised by these Terms, including your use of the App and any Services; and
                            </li>
                            <li>
                                you must immediately delete or remove the App from all Devices, and immediately destroy all copies of the App then in your possession, custody or control and certify to us that you have done so.
                            </li>
                        </ol>
                    </ol>
                    <li>
                        <Text strong>COMMUNICATION BETWEEN US</Text>
                    </li>
                    <ol>
                        <li>
                            If you wish to contact us in writing, or if any condition in these Terms requires you to give us notice in writing, you can send this to us by e-mail at enquiries@duradiamondsoftware.co.uk. We will confirm receipt of this by contacting you in writing, normally by e-mail.
                        </li>
                        <li>
                            If we have to contact you or give you notice in writing, we will do so by e-mail or by pre-paid post to the address you provide to us in your request for the App.
                        </li>
                    </ol>
                    <li>
                        <Text strong>OTHER IMPORTANT TERMS</Text>
                    </li>
                    <ol>
                        <li>
                            We may transfer our rights and obligations under these Terms to another organisation, but this will not affect your rights or our obligations under these Terms.
                        </li>
                        <li>
                            You may only transfer your rights or obligations under these Terms to another person if we agree in writing.
                        </li>
                        <li>
                            If we fail to insist that you perform any of your obligations under these Terms, or if we do not enforce our rights against you, or if we delay in doing so, that will not mean that we have waived our rights against you and will not mean that you do not have to comply with those obligations. If we do waive a default by you, we will only do so in writing, and that will not mean that we will automatically waive any later default by you.
                        </li>
                        <li>
                            Each of the conditions of these Terms operates separately. If any court or competent authority decides that any of them are unlawful or unenforceable, the remaining conditions will remain in full force and effect.
                        </li>
                        <li>
                            Please note that these Terms, their subject matter and the formation of any contract with you under these Terms, are governed by English law. You and we both agree that the courts of England and Wales will have exclusive jurisdiction to deal with any dispute arising under or otherwise relating to these Terms.
                        </li>
                    </ol>
                </ol>
            </Paragraph>
            <Divider />
        </Typography>
    </NoSidebarLayout>
  )
}
export default TermsAndConditionsPage;